// src/components/portfolio/PortfolioModals.js
import React from 'react';
import AddCategoryModal from './AddCategoryModal';
import AddAssetModal from './add-asset';
import { usePortfolio } from '../../contexts/PortfolioContext';

function PortfolioModals({ 
  modalState = {}, 
  onCategorySubmit, 
  onAssetSubmit,
  setModalState,
  portfolioData
}) {
  const { selectedPortfolio } = usePortfolio();

  const handleAssetModalClose = () => {
    setModalState(prev => ({
      ...prev,
      showAddAsset: false,
      selectedParentPath: null
    }));
  };

  const handleCategoryModalClose = () => {
    setModalState(prev => ({
      ...prev,
      showAddCategory: false,
      selectedParentPath: null
    }));
  };

  return (
    <>
      {modalState.showAddAsset && (
        <AddAssetModal
          isOpen={modalState.showAddAsset}
          onClose={handleAssetModalClose}
          onAdd={(assetData) => {
            onAssetSubmit(assetData);
            handleAssetModalClose();
          }}
          parentCategory={modalState.selectedParentPath}
          portfolioData={portfolioData}
          selectedPortfolio={selectedPortfolio}
        />
      )}

      {modalState.showAddCategory && (
        <AddCategoryModal
          isOpen={modalState.showAddCategory}
          onClose={handleCategoryModalClose}
          onAdd={onCategorySubmit}
          parentCategory={modalState.selectedParentPath}
        />
      )}
    </>
  );
}

export default PortfolioModals;